import { H5 } from '../Text';
import { Button, IButtonProps } from './Button';
import { brandConfig } from 'utils/brand';
import { classNames } from 'utils/classNames';

export interface ISolidButtonProps extends IButtonProps {
  textColor?: string;
  textClassName?: string;
  buttonType?: 'button' | 'submit' | 'reset';
}

export const SolidButton: React.FC<ISolidButtonProps> = ({
  className,
  children,
  textColor,
  textClassName,
  buttonType,
  ...props
}) => {
  return (
    <Button
      buttonType={buttonType}
      className={classNames(
        className,
        props.disabled
          ? 'bg-tt-light-gray-purple-line'
          : 'bg-tt-yellow hover:bg-tt-dark-yellow',
        'rounded',
      )}
      {...props}>
      <H5
        as="span"
        className={classNames(
          'block',
          textColor || brandConfig.solidButtonText,
          textClassName,
        )}>
        {children}
      </H5>
    </Button>
  );
};
